
import { appConst, Component, FormPageMixins, Mixins, PageResultModalMixins } from "@/lib";
import Income from "@/store/modules/foreignexchangecollection/income/entity"
import IncomeDetail from "@/store/modules/foreignexchangecollection/incomedetail/entity"
import moment from "moment"

import CardTitleView from "@/components/card-title/index.vue"
import CreateIncomeDetailModal from "./create-income-detail.vue"

class EditRow {
  index: number;
  data: IncomeDetail;

  constructor() {
    this.index = -1;
    this.data = new IncomeDetail();
  }
}
@Component({components: {CardTitleView, CreateIncomeDetailModal}})
export default class ReceivePaymentView extends Mixins(FormPageMixins, PageResultModalMixins) {
  model = new Income();
  editRow:EditRow = new EditRow();
  loading = false;

  get record() {
    return this.$store.state.foreignexchangecollection.income.editIncome as Income;
  }

  get businessGroup() {
    return this.getCodeDescription(appConst.codeCategory.businessGroup, this.model.businessGroup)
  }

  get currency() {
    return this.getCodeDescription(appConst.codeCategory.currency, this.model.currency)
  }

  // 逾期天数：当前日期超过应付款日的天数。若未到期，则显示【未逾期】，否则显示逾期天数（比如：1天），同时颜色为红色
  get prePaymentDays() {
    const notExpiredText = this.getCodeDescription(appConst.codeCategory.incomeStatus, appConst.incomeStatus.notExpired);
    const dayText = this.L('app.Income.Day');
    let currentDate = this.$util.format.date(Date.now());
    if (!!this.model.prePaymentDate && this.$util.format.date(this.model.prePaymentDate) < currentDate) {
      let days = moment(currentDate).diff(moment(this.model.prePaymentDate), 'days');
      return {text: `${days}${dayText}`, days: days};
    }
    return {text: notExpiredText, days: 0};
  }
  get restDays() {
    const notExpiredText = this.getCodeDescription(appConst.codeCategory.incomeStatus, appConst.incomeStatus.notExpired);
    const dayText = this.L('app.Income.Day');
    let currentDate = this.$util.format.date(Date.now());
    if (!!this.model.restDate && this.$util.format.date(this.model.restDate) < currentDate) {
      let days = moment(currentDate).diff(moment(this.model.restDate), 'days');
      return {text: `${days}${dayText}`, days: days};
    }
    return {text: notExpiredText, days: 0};
  }
  // 收款类型
  get incomeTypeList() {
    return this.getCodeListByCategory(appConst.codeCategory.incomeType)
  }

  get column() {
    let list = [
      this.$util.render.baseColumn("app.SystemCode.SequenceNo", 100, {type: "index", align: 'center'}),
      
      this.$util.render.baseColumn("app.IncomeDetail.Amount", null, {key: "amount", minWidth: 100, maxWidth: 150, render: (h: any, params: any) => {
        return [h("span", this.$util.format.amount(params.row.amount))];
      }}),
      this.$util.render.baseColumn("app.IncomeDetail.BankFee", null, {key: "bankFee", minWidth: 100, maxWidth: 150, render: (h: any, params: any) => {
        return [h("span", this.$util.format.amount(params.row.bankFee))];
      }}),
      this.$util.render.dateColumn("app.IncomeDetail.IncomeDate", "incomeDate"),
      this.$util.render.baseColumn("app.IncomeDetail.Remark", null, {key: "remark", minWidth: 100}),
      this.$util.render.baseColumn("Action.Actions", null, {key: "actions", slot: "actions", width: 100, fixed: 'right'})
    ];
    if (this.model.isAdvance) {
      list.splice(1, 0, this.$util.render.codeColumn("app.IncomeDetail.IncomeType", "incomeType", () => { return this.incomeTypeList }, {minWidth: 120}))
    }
    return list;
  }

  get options() {
    let that = this;
    if (this.model.isAdvance) {
      return {
        prePaymentDate: {
          disabledDate (date) {
            let restDate = that.$util.format.date(that.model.restDate, appConst.dateFormat.startOfDay)
            return date > new Date(restDate);
          }
        },
        restDate: {
          disabledDate (date) {
            let prePaymentDate = that.$util.format.date(that.model.prePaymentDate, appConst.dateFormat.startOfDay)
            return date < new Date(prePaymentDate);
          }
        }
      }
    } else {
      return {
        prePaymentDate: {
          
        },
        restDate: {
          
        }
      }
    }
    
  }

  get restAmount() {
    return this.$util.format.amount(this.model.restAmount);
  }

  async created() {
    Object.assign(this.config,{
      labelWidth: 80,
      isRedirectIndex: true,
      getAction: "foreignexchangecollection/income/getByDeclareCustomsId",
      okAction: "foreignexchangecollection/income/save",
      isHideOk: true
    })
  }

  /**
   * 预付款修改
   */
  prePaymentAmountChange() {
    this.model.restAmount = Number.parseFloat((this.model.receiverAmount - this.model.prePaymentAmount).toFixed(2));
  }

  handleCreate() {
    this.editRow.index = -1;
    let detailData = new IncomeDetail();
    if (!this.model.isAdvance) {
      detailData.incomeType = appConst.incomeType.prepayment
    }
    detailData.currency = this.model.currency;
    detailData.currency_en = this.model.currency_en;
    detailData.prePaymentAmount = this.model.prePaymentAmount;
    detailData.restAmount = this.model.restAmount;
    detailData.isAdvance = this.model.isAdvance;
    this.model.incomeDetailList.forEach(item => {
      if (item.incomeType == appConst.incomeType.prepayment) {
        detailData.prePaymentAmount = detailData.prePaymentAmount - item.amount - item.bankFee;
      } else {
        detailData.restAmount = detailData.restAmount - item.amount - item.bankFee;
      }
    })
    if (detailData.prePaymentAmount < 0) {
      detailData.prePaymentAmount = 0;
    }
    if (detailData.restAmount < 0) {
      detailData.restAmount = 0;
    }
    this.$store.commit("foreignexchangecollection/income/editDetail", detailData);
    this.open("create-income-detail-modal");
  }

  /**
   * 创建成功
   */
  createSuccess(value) {
    if (this.editRow.index > -1) {
      this.$set(this.model.incomeDetailList[this.editRow.index], "incomeType", value.incomeType);
      this.$set(this.model.incomeDetailList[this.editRow.index], "amount", value.amount);
      this.$set(this.model.incomeDetailList[this.editRow.index], "bankFee", value.bankFee);
      this.$set(this.model.incomeDetailList[this.editRow.index], "currency", value.currency);
      this.$set(this.model.incomeDetailList[this.editRow.index], "currency_en", value.currency_en);
      this.$set(this.model.incomeDetailList[this.editRow.index], "incomeDate", value.incomeDate);
      this.$set(this.model.incomeDetailList[this.editRow.index], "remark", value.remark);
    } else {
      this.model.incomeDetailList.push(value);
    }
    
  }

  /**
   * 编辑
   */
  handleEdit(index) {
    this.editRow.index = index;
    let detailData = {
      editRowIndex: index,
      incomeType: this.model.incomeDetailList[index].incomeType,
      amount: this.model.incomeDetailList[index].amount,
      bankFee: this.model.incomeDetailList[index].bankFee,
      currency: this.model.currency,
      currency_en: this.model.currency_en,
      incomeDate: this.model.incomeDetailList[index].incomeDate,
      remark: this.model.incomeDetailList[index].remark,
      prePaymentAmount: this.model.prePaymentAmount,
      restAmount: this.model.restAmount,
      isAdvance: this.model.isAdvance,
    }
    this.$store.commit("foreignexchangecollection/income/editDetail", detailData);
    this.open("create-income-detail-modal");
  }

  handleDelete(index) {
    this.model.incomeDetailList.splice(index, 1);
  }
  /**
   * 保存
   */
  save() {
    this.submitIncome("foreignexchangecollection/income/save")
  }
  /**
   * 全部收汇
   */
  confirm() {
    this.submitIncome("foreignexchangecollection/income/confirm", true);
  }

  submitIncome(okAction, validate: boolean = false) {
    (this.$refs["form-page"] as any).formValidate(async (model: any) => {
      if (!validate) {
        await this.submitAction(okAction);
        return;
      }
      let amount = 0;
      this.model.incomeDetailList.forEach(item => {
        amount = amount + item.amount + item.bankFee;
      });
      // 到账金额与收汇金额不一致
      if (amount != this.model.receiverAmount) {
        this.$Modal.confirm({
          title: this.L("app.Income.ConfirmWarning"),
          content: this.L("app.Income.ConfirmWarningText"),
          onOk:async ()=>{
              await this.submitAction(okAction);
          },
          onCancel:()=>{
            return;
          }
        })
        return;
      }
      await this.submitAction(okAction);
    });
  }

  async submitAction(okAction) {
    this.loading = true;
    await this.$store.dispatch({ type: okAction, data: this.model }).finally(() => {
      this.loading = false;
    });

    this.$Message.success(this.L("Tip.SavedSuccessfully"));
    this.back();
  }
}
